<template>
    <div class="container">
        <div class="card">
            <div class="card-header">
                <h1 class="mb-0">Glossar</h1>
            </div>
            <div class="card-body">
                <div class="wpb_wrapper">
                    <input
                        class="form-control lexicon-search"
                        autocomplete="off"
                        v-model="search"
                        placeholder="Suche.."
                    />
                    <hr />
                    <div class="btn-group-sm" role="group">
                        <a
                            v-for="letter in glossaryLetters"
                            :key="letter"
                            type="button"
                            class="btn btn-sm btn-default lexicon-char-link"
                            :href="'#char-' + letter">
                            {{letter}}
                        </a>
                    </div>
                    <hr />
                    <div class="lexicon-container">
                        <div v-for="(entries, letter) in glossaryGroups" :key="letter" class="lexicon-entry">
                            <h1>
                                <span class="lexicon-char" :id="'char-' + letter">{{ letter }}</span>
                            </h1>
                            <div v-for="entry in entries" :key="entry.glossary.id + ',' + entry.id" class="row">
                                <div class="col-md-6 lexicon-key">{{entry.name}}</div>
                                <div class="col-md-6 lexicon-value">{{entry.glossary.title}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            glossaryFetchUrl: String
        },
        data() {
            return {
                search: '',
                glossaries: []
            };
        },
        computed: {
            glossaryLetters() {
                return _.keys(this.glossaryGroups);
            },
            glossaryGroups() {
                return _.groupBy(this.glossaryItems, (glossary) => {
                    return glossary.name.charAt(0).toUpperCase()
                });
            },
            glossaryItems() {
                let entries = this.glossaries
                    .flatMap((g) => g.types.map((t) => ({...t, glossary: g})))
                    .filter((item) => !this.search.length || item.name.toLowerCase().includes(this.search.toLowerCase()));


                return _.sortBy(entries, 'name');
            }
        },
        mounted() {
            axios.get(this.glossaryFetchUrl).then((response) => {
                this.glossaries = response.data.data;
            });
        },
        methods: {}
    }
</script>
